module.exports = __webpack_public_path__ + "img/Shallow Setting.0c01d217.png";